import { ContentDiv, FlexSection, HighlightedSection } from "components/containers";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { ResponsiveImage } from "../../../components/ResponsiveImage";
import { ConceptCard, ContactForm, ContactSection, DataGrid } from "./styles";
import { Mail, Phone } from "../../../components/Icons/Generic";
import { BlogCard } from "../../../components/BlogCard";
import { InputLabel } from "../../../components/Input";
import { Button } from "../../../components/Button";
import { IEmail } from "../../../interfaces/intarfaces";

export const Partners: React.FC = () => {
    const { t, i18n } = useTranslation('partners');
    const [loading, setLoading] = useState(false);

    const sendData = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        setLoading(true);

        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                type: "partner",
                first_name: e.currentTarget.first_name.value as string,
                phone: e.currentTarget.phone.value as string,
                browser_language: i18n.language,
            } as IEmail)
        };

        fetch(
            process.env.REACT_APP_AWS_ENDPOINT! +
            `contact-us/${e.currentTarget.email.value as string}`,
            requestOptions
        )
            .then((response) => response.json())
            .then((data) => {
                setLoading(false);
            });

        e.currentTarget.reset()
    }

    return (
        <ContentDiv>
            <h1>{t("partners.title")}</h1>
            <FlexSection
                grow={40}
            >
                <ResponsiveImage
                    imgSrc={"rootpage/partners/presentation"}
                    mobileSize={'95vw'}
                    tabletSize={'40vw'}
                    desktopSize={'50vw'}
                    aspectRatio={'4/3'}
                    minWidth={'22rem'}
                />
                <div>
                    <h3>{t("partners.philosophy.header")}</h3>
                    <h2>{t("partners.philosophy.title")}</h2>
                    <p>{t("partners.philosophy.description")}</p>
                </div>
            </FlexSection>
            <section>
                <h3>{t("partners.concept.header")}</h3>
                <h2>{t("partners.concept.title")}</h2>
                <FlexSection grow={20}>
                    <ConceptCard>
                        <div>1</div>{t("partners.concept.1.title")}
                        <p>{t("partners.concept.1.description")}</p>
                    </ConceptCard>
                    <ConceptCard>
                        <div>2</div>{t("partners.concept.2.title")}
                        <p>{t("partners.concept.2.description")}</p>
                    </ConceptCard>
                    <ConceptCard>
                        <div>3</div>{t("partners.concept.3.title")}
                        <p>{t("partners.concept.3.description")}</p>
                    </ConceptCard>
                </FlexSection>
            </section>
            <FlexSection
                grow={40}
                reverse
            >
                <ResponsiveImage
                    imgSrc={"team/joost"}
                    mobileSize={'95vw'}
                    tabletSize={'40vw'}
                    desktopSize={'50vw'}
                    aspectRatio={'4/3'}
                    minWidth={'22rem'}
                />
                <div>
                    <h3>{t("partners.collaboration.header")}</h3>
                    <h2>{t("partners.collaboration.title")}</h2>
                    <p>{t("partners.collaboration.description")}</p>
                    <HighlightedSection>{Mail}joost@hospihousing.com</HighlightedSection>
                    <HighlightedSection>{Phone}06 13388424</HighlightedSection>
                </div>
            </FlexSection>
            <FlexSection
                grow={40}
            >
                <DataGrid>
                    <div>
                        <h2>10.000+</h2>
                        <p>{t("partners.data.1")}</p>
                    </div>
                    <div>
                        <h2>150+</h2>
                        <p>{t("partners.data.2")}</p>
                    </div>
                    <div>
                        <h2>600+</h2>
                        <p>{t("partners.data.3")}</p>
                    </div>
                    <div>
                        <h2>4,7 / 5</h2>
                        <p>{t("partners.data.4")}</p>
                    </div>
                </DataGrid>
                <div>
                    <h3>{t("partners.data.header")}</h3>
                    <h2>{t("partners.data.title")}</h2>
                    <p>{t("partners.data.description")}</p>
                </div>
            </FlexSection>
            <section>
                <h3>{t("partners.proud.header")}</h3>
                <h2>{t("partners.proud.title")}</h2>
                <FlexSection grow={30} notCentering>
                    <BlogCard post_id={23} short_desc={true} />
                    <BlogCard post_id={25} short_desc={true} />
                    <BlogCard post_id={42} short_desc={true} />
                </FlexSection>
            </section>
            <ContactSection>
                <FlexSection grow={20}>
                    <div style={{ minWidth: "20em" }}>
                        <h2>{t("partners.call.title")}</h2>
                        <p>{t("partners.call.description")}</p>
                    </div>
                    <ContactForm onSubmit={(e) => sendData(e as React.FormEvent<HTMLFormElement>)}>
                        <h2>Contact</h2>
                        <p>{t("partners.call.name")}</p>
                        <InputLabel
                            name="first_name"
                            placeholder={t("partners.call.name")}
                            required
                        />
                        <p>{t("partners.call.email")}</p>
                        <InputLabel
                            name="email"
                            placeholder={t("partners.call.email")}
                            pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                            required
                        />
                        <p>{t("partners.call.phone")}</p>
                        <InputLabel
                            name="phone"
                            placeholder={t("partners.call.phone")}
                            pattern="^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$"
                        />
                        <Button type="submit" loading={loading}>
                            {t("partners.call.contact")}
                        </Button>
                    </ContactForm>
                </FlexSection>
            </ContactSection>
        </ContentDiv>
    );
}
